<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="9" class="d-flex justify-start align-center"><h2>Banner</h2></v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-btn
        color="primary"
        small
        depressed
        @click="
          formData = {
            id: '',
            name: '',
            link: '',
            status: 1,
            type: 'slider',
            image_filename: '',
            image: '',
          }
          formNavigationDrawer = true
          $refs.formChild.clearForm()
        "
        >Tambah</v-btn
      >
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          <h5>Filter</h5>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-text-field label="Cari" outlined dense v-model="search" :hide-details="true" />
            </v-col>
            <v-col cols="4">
              <v-select
                :hide-details="true"
                :items="statuses"
                outlined
                dense
                item-text="name"
                item-value="value"
                v-model="selectedStatus"
                label="Status"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" small @click="getData" depressed>Filter</v-btn>
          <v-btn
            color="primary"
            small
            depressed
            outlined
            class="ml-3"
            @click="
              search = ''
              selectedStatus = ''
              getData()
            "
            >Reset</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="data"
        :options.sync="options"
        :server-items-length="total"
        :loading="loadingTable"
        class="elevation-1"
        :items-per-page="limit"
        :footer-props="{
          'items-per-page-options': [5, 10, 50, 100],
        }"
      >
        <template v-slot:[`item.option`]="{ item }">
          <v-row>
            <v-col cols="12">
              <v-btn
                color="warning"
                x-small
                class="mr-3"
                @click="
                  formNavigationDrawer = true
                  formData = {
                    id: item.id,
                    name: item.name,
                    link: item.link,
                    status: item.status,
                    type: item.type,
                    image_filename: getFileName(item.image),
                    image: '',
                  }
                "
                >Ubah</v-btn
              >
              <v-btn
                color="error"
                x-small
                @click="
                  deleteDialog = true
                  selectedDelete = item
                "
                >Hapus</v-btn
              >
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          {{ item.status == 1 ? 'Aktif' : 'Tidak Aktif' }}
        </template>
        <template v-slot:[`item.img`]="{ item }">
          <img :src="item.image" style="width: 150px;" />
        </template>
      </v-data-table>
    </v-col>

    <v-snackbar v-model="alert.status" :timeout="timeout" :color="alert.success ? 'success' : 'error'" right bottom>
      {{ alert.message }}
    </v-snackbar>

    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title>Yakin dihapus?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div>
            <v-btn
              color="error"
              small
              depressed
              class="mr-2"
              :loading="loadingDeleteButton"
              :disabled="loadingDeleteButton"
              @click="deleteData"
              >Ya</v-btn
            >
            <v-btn color="error" outlined depressed small @click="deleteDialog = false">Tidak</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- FORM EDIT -->
    <v-navigation-drawer v-model="formNavigationDrawer" fixed bottom temporary right width="380">
      <Form :selectedData="formData" ref="formChild" :closeNav="closeNav" :setAlert="setAlert" :getData="getData" />
    </v-navigation-drawer>
  </v-row>
</template>

<script>
import { mdiSquareEditOutline, mdiDotsVertical, mdiRefresh, mdiFileOutline } from '@mdi/js'
import axios from 'axios'
import Form from './components/Form.vue'
export default {
  components: { Form },
  setup() {
    return {
      // icons
      icons: {
        mdiSquareEditOutline,
        mdiDotsVertical,
        mdiRefresh,
        mdiFileOutline,
      },
    }
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem('user'))
    },
  },
  data() {
    return {
      alert: {
        status: false,
        success: false,
        message: '',
      },
      timeout: 1200,
      loadingTable: false,
      total: 0,
      data: [],
      limit: 10,
      search: '',
      statuses: [
        { name: 'Pilih Semua', value: '' },
        { name: 'Aktif', value: 1 },
        { name: 'Tidak Aktif', value: 0 },
      ],
      selectedStatus: '',
      headers: [
        { text: '#', value: 'img', sortable: false },
        { text: 'Nama', value: 'name', sortable: false },
        { text: 'Tipe', value: 'type', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Opsi?', value: 'option', sortable: false },
      ],
      options: {},
      formData: {
        id: '',
        name: '',
        link: '',
        status: 1,
        type: 'slider',
        image_filename: '',
        image: '',
      },
      selectedDelete: null,
      deleteDialog: false,
      formNavigationDrawer: false,
      loadingDeleteButton: false,
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    },
  },
  methods: {
    getData() {
      this.loadingTable = true
      this.data = []
      const token = localStorage.getItem('token')
      const { page, itemsPerPage } = this.options
      const params = {
        page,
        limit: itemsPerPage,
        q: this.search,
        status: this.selectedStatus ?? '',
      }
      const paramsString = new URLSearchParams(params).toString()
      axios
        .get(`${process.env.VUE_APP_API_ENDPOINT}banner?${paramsString}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(res => {
          this.loadingTable = false
          if (res.status == 200) {
            const data = res.data
            if (data.success) {
              this.total = data.data.count
              this.data = data.data.rows
            } else {
              this.alert = {
                status: true,
                success: false,
                message: data.message,
              }
            }
          } else {
            this.alert = {
              status: true,
              success: false,
              message: res.statusText,
            }
          }
        })
        .catch(err => {
          this.loadingTable = false
          const response = err.response
          const data = response.data
          this.alert = {
            status: true,
            success: false,
            message: data.message,
          }
          if (data.message == 'Anda tidak diberikan akses!') {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            this.$router.push({ name: 'login' })
          }
        })
    },
    setAlert(value) {
      this.alert = value
    },
    closeNav() {
      this.formNavigationDrawer = false
    },
    deleteData() {
      this.loadingDeleteButton = true
      const token = localStorage.getItem('token')
      axios
        .delete(`${process.env.VUE_APP_API_ENDPOINT}banner/${this.selectedDelete.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(res => {
          this.loadingDeleteButton = false
          this.deleteDialog = false
          if (res.status == 200) {
            this.alert = {
              status: true,
              success: res.data.success,
              message: res.data.message,
            }
          } else {
            this.alert = {
              status: true,
              success: false,
              message: res.statusText,
            }
          }
          this.getData()
        })
        .catch(err => {
          this.loadingDeleteButton = false
          this.deleteDialog = false
          const response = err.response
          const data = response.data
          this.alert = {
            status: true,
            success: false,
            message: data.message,
          }
          if (data.message == 'Anda tidak diberikan akses!') {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            this.$router.push({ name: 'login' })
          }
        })
    },
    getFileName(value) {
      return value.split('\\').pop().split('/').pop()
    },
  },
}
</script>

<style>
</style>